import './modal.scss';

import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

class Modal {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-modal',
            modalAttr: 'data-modaltarget',
            scrollerAttr: 'scroller',
            onAjaxLoaded: null,
            onClosed: null,
            loader: null
        };

        this.settings = Object.assign({}, defaults, options);
        this.$modal = element;
        this.modalOpen = false;
        this.$modalTarget = null;
        this.$modalScroller = null;
        this.movedModalToMainLayout = false;
        this.modalIframeURL = this.$modal.getAttribute('data-iframe-url');
        this.$fullImageSrc = this.$modal.dataset.modalImageSrc;
        const modalId = this.$modal.getAttribute('data-modal');

        if (modalId) {
            this.$modalTarget = document.getElementById(modalId);

            if (this.$fullImageSrc) {
                this.$fullsizeImage = this.$modalTarget.querySelector('img');
            }
        }
    }

    initialize () {
        this.setEvents();

        if (this.$modalTarget !== null) {
            this.toggleTabIndex('hide');
            this.movedModalToMainLayout = this.$modalTarget.getAttribute('data-modal-move');
        }

        if (this.movedModalToMainLayout === 'true') {
            const $modalBlob = document.getElementById('modal-blob');
            if ($modalBlob) {
                const $modal = $modalBlob.querySelector(`#${this.$modalTarget.id}`);

                if (!$modal) {
                    $modalBlob.appendChild(this.$modalTarget);
                }
            }
        }
    }

    toggleTabIndex (toggle) {
        const $clickableItems = this.$modalTarget.querySelectorAll('button, a, input, select, textarea');
        $clickableItems.forEach(($item) => {
            if (toggle === 'hide') {
                $item.setAttribute('tabindex', -1);
            } else {
                $item.removeAttribute('tabindex');
            }
        });
    }

    setEvents () {
        this.$modal.addEventListener('click', (e) => {
            e.preventDefault();
            this.openModal();
        });

        if (this.$modal.getAttribute('data-modal-open') !== null) {
            window.setTimeout(() => {
                this.openModal();
            }, 500);
        }

        // open modal on enter or space key
        this.$modal.addEventListener('keydown', (e) => {
            if (e.code === 'Enter' || e.code === 'Space') {
                this.openModal();
            }
        });

        // close modal on ESC key
        document.addEventListener('keydown', (e) => {
            let isEscape = false;
            if ('key' in e) {
                isEscape = (e.key === 'Escape' || e.key === 'Esc');
            } else {
                isEscape = (e.keyCode === 27);
            }
            if (isEscape && this.modalOpen === true) {
                this.closeModal();
            }
        });
    }

    openModal () {
        if (this.$modalTarget) {
            if (this.$fullsizeImage && this.$fullImageSrc) {
                this.setImageSource();
            }

            this.showModal();
            this.toggleTabIndex('show');
            this.$modalTarget.setAttribute('aria-hidden', 'false');
        }
    }

    setImageSource () {
        this.$fullsizeImage.src = this.$fullImageSrc;
    }

    showModal () {
        this.$modalScroller = this.$modalTarget.querySelector('[' + this.settings.modalAttr + '="' + this.settings.scrollerAttr + '"]');
        this.$modalTarget.classList.add('is--active');

        const $modalIframeBlob = this.$modalTarget.querySelector('[data-modaltarget-iframe-blob]');
        if ($modalIframeBlob && this.modalIframeURL) {
            $modalIframeBlob.innerHTML = `<iframe src="${this.modalIframeURL}" frameborder="0"></iframe>`;
        }

        this.$modalTarget.focus();

        if (this.$modalScroller) {
            disableBodyScroll(this.$modalScroller);
        }

        const $$exists = this.$modalTarget.querySelectorAll('[data-modal-close]');
        $$exists.forEach(($exit) => {
            $exit.addEventListener('click', (e) => {
                e.preventDefault();
                this.closeModal();
            });
        });

        this.modalOpen = true;
        this.$modalTarget.API = this;
    }

    closeModal () {
        this.$modalTarget.classList.remove('is--active');
        this.$modalTarget.setAttribute('aria-hidden', 'true');

        const $modalIframeBlob = this.$modalTarget.querySelector('[data-modaltarget-iframe-blob]');
        if ($modalIframeBlob) {
            $modalIframeBlob.innerHTML = '';
        }

        if (this.$modalScroller) {
            enableBodyScroll(this.$modalScroller);
        }

        this.modalOpen = false;

        if (typeof this.settings.onClosed === 'function') {
            this.settings.onClosed(this.$modalTarget);
        }
    }
}

export { Modal };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$modal = $context.querySelectorAll('[data-modal]');

        for (let i = 0; i < $$modal.length; i++) {
            const $modal = new Modal($$modal[i]);
            $modal.initialize();
        }
    }
});
